import { render, staticRenderFns } from "./POSStore.vue?vue&type=template&id=69cf6aac&scoped=true"
import script from "./POSStore.vue?vue&type=script&lang=ts"
export * from "./POSStore.vue?vue&type=script&lang=ts"
import style0 from "./POSStore.vue?vue&type=style&index=0&id=69cf6aac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cf6aac",
  null
  
)

export default component.exports